import React from 'react';
import {Container, ContainerInner, Logo, Avatar} from './styles';

const Header =  ({ history, updateUserMenu, userMenu, handleUserLogout}) => (
    <Container>
        <ContainerInner>
            <div>
                <Logo onClick={() => history.push('/dashboard')}>Form Builder</Logo>
            </div>
            <div>
                <li className="dropdown" style={{listStyle: 'none'}}>
                    <p className="m-0 nav-link cursor-pointer waves-effect waves-light nav-user text-white" onClick={updateUserMenu}>
                        Username <Avatar src={'/Assets/avatar.png'} />
                    </p>
                    <div className={"dropdown-menu dropdown-menu-end " + (userMenu ? "show" : "")} style={{right: '5px'}}>
                        <p className="dropdown-item cursor-pointer m-0" onClick={handleUserLogout}>Logout</p>
                    </div>
                </li>
            </div>
        </ContainerInner>
    </Container>
);

export default Header;